<template>
  <div class="container">
    <div class="app-footer">
      <div class="app-footer__wrapper">
        <div class="app-footer__inner">
          <slot />

          <p class=" text-xs">
            {{ footerData.p1 }}
            <br><br>
            {{ footerData.p2 }}
            <br><br>
            {{ footerData.p3 }}
            <br><br>
            {{ footerData.p4 }}
            <br><br>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import theme from '@/mixins/theme'

export default {
  // Name
  name: 'ClearScorePrimeFooter',

  // Mixins
  mixins: [
    theme
  ],

  // Data
  data () {
    return {
      footerData: {
        p1: "You will only receive an offer if you meet Spring's current credit standards. Any offer received is conditional to Spring's standard review which includes, amongst others, verification of your identity, of information obtained or provided as part of your application and of your ability to pay. Spring loans range from $500 to $35,000 with terms from 6 to 84 months with interest rates between 9.99% and 34.95% and Annual Percentage Rates (APR) between 9.99% to 35.00%. Loan amount and APR offered will depend on assessment of your credit profile. Offer excludes residents of Quebec or Saskatchewan",
        p2: "The Equifax Risk Score [or Equifax credit score] is based on Equifax's proprietary model and may not be the same score used by third parties to assess your creditworthiness. The provision of this score to you is intended for your own educational use. Third parties will take into consideration other information in addition to a credit score when evalutating your creditworthiness. ",
        p3: 'Equifax Canada Co. ("Equifax") is a registered Canadian credit bureau that maintains your Canadian consumer credit file, which has been used by Spring Financial Inc. as permitted by you, to provide you with your edicational Equifax credit score. The Equifax credit score provided here is current as of the date indicated by Spring Financial Inc. ',
        p4: 'Spring Financial Inc. is not affiliated with Equifax Canada Co., its parent company, subsidiaries or its affiliates (collectively, "Equifax"). The content of this website is not reviewed nor approved by Equifax. Spring Financial Inc. is an authorized reseller of the Equifax Risk Score, however, Equifax does not endorse, guarantee or recomment any of the products, services or content on this website. For information about Equifax, the Equifax Risk Score, and/or Equifax credit reports, please visit the official Equifax Canada Co. website at https://www.consumer.equifax.ca/personal/.'
      }
    }
  }

}
</script>

<style scoped lang="scss">
.app-footer {
  @apply pb-30 text-black-500 w-full pt-50;

  @screen sm {
    @apply mb-15;
  }

  @screen md {
    @apply mb-0;
  }

  small {
    @apply block text-xs leading-3 mb-30;
  }

  &__wrapper {
    @apply border-t border-solid border-black-200 flex justify-center;
  }

  &__inner {
    @apply max-w-500 pt-50;

    @screen md {
      @apply max-w-none;
    }
  }

  &__link {
    @apply text-xs relative inline-block mr-20;

    &::after {
      @apply block absolute pointer-events-none -top-px -right-3;

      content: '|';
    }

    &:last-child {
      margin-right: 0;

      &::after {
        display: none;
      }
    }
  }

  &__license {
    @apply underline cursor-pointer;
  }
}

.footer-container {
  @apply flex flex-row items-center justify-center border-1 p-5 rounded-10 font-display;

  &__middle {
    @apply justify-between w-full grid gap-y-5 grid-rows-3 mb-20;

    @screen sm {
      @apply gap-y-0 gap-x-5 grid-cols-3 grid-rows-1;
    }
  }

  &__title {
    @apply font-bold text-2xl;
  }

  img {
    @apply my-10 mx-20;
  }

  &.hidden {
    @apply hidden;
  }
}
</style>
